import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { dateFormatter } from '../../../../../utils';


const TABLE_HEADER = [
  {
    header: 'Patient Name',
    accessor: 'patient_name'
  },
  {
    header: 'Ipd No',
    accessor: 'ipd_no'
  },

];

const ROOM_HISTORY_HEADER = [
  {
    header: 'Transfer Date ',
    accessor: ''
  },
  {
    header: 'Time',
    accessor: 'time'
  },
  {
    header: 'Old Ward',
    accessor: (row) => row?.ward?.name
  },
  {
    header: 'Old Room',
    accessor: (row) => row?.room?.room_no
  },
  {
    header: 'Old Bed No.',
    accessor: 'bed_no'
  },
  {
    header: 'New Ward',
    accessor: (row) => row?.transfer_ward?.name
  },
  {
    header: 'New Room',
    accessor: (row) => row?.transfer_room?.room_no
  },

  {
    header: 'New Bed No.',
    accessor: 'transfer_bed_no'
  },
];




const initialRoomTransferDataObj = {
  data: [],
  loading: false
};

export const RoomTransferAccept = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [roomTransferDataObj, setRoomTransferDataObj] = useState(initialRoomTransferDataObj);
  const [collectionSampleFilter, setCollectionSampleFilter] = useState('All');
  const [grn, setGrn] = useState([])
  const [selectedProduct, setSelectedProduct] = useState(false)
  const [productDetails, setProductDetails] = useState([])
  const [consignment, setConsignment] = useState([])
  const [mergedData, setMergedData] = useState([]);
  const [stock, setStock] = useState([])
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [stockDetails, setStockDetails] = useState([]);

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getCurrentDateTime('date'),
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });

  const { handleSubmit, reset, setValue } = methods;
  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setDetailList(selectedRecord.service_items);
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
    } else {
      reset();
    }
  }, [selectedRecord]);



  // const handlePatientData = async () => {
  //   setRoomTransferDataObj({ loading: true });
  //   try {
  //     const response = await request('/room-transfer-list', { method: 'GET' });
  //     if (response.success) {
  //       const sortedData = response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
  //       const filteredData = sortedData.filter(item =>
  //         item.status === 'active' || item.status === 'inactive' || item.status === 'default'
  //       );
  //       setRoomTransferDataObj({ loading: false, data: filteredData });
  //     } else {
  //       toast('Error in fetching data', { variant: 'error' });
  //       setRoomTransferDataObj({ loading: false });
  //     }
  //   } catch (error) {
  //     console.error('Error fetching patient data:', error);
  //     toast('Error in fetching data', { variant: 'error' });
  //     setRoomTransferDataObj({ loading: false });
  //   }
  // };



  // useEffect(() => {
  //   handlePatientData()
  // }, [handlePatientData])


  const handleRowClick = (row) => {
    const filteredProducts = mergedData.filter(product => product.batch_no === row.batch_no);
    if (filteredProducts.length > 0) {
      setProductDetails(filteredProducts);
      console.log("HELLO PRODUCT DETAILS", filteredProducts);
    }
  }


  const filterUniqueProducts = (consignmentData) => {
    const filteredData = consignmentData.reduce((acc, current) => {
      const x = acc.find(item => item.
        batch_no === current.
          batch_no);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredData;
  };
  const formSubmit = async (formValues) => {
    setLoading(true);
    const payload = { ...formValues, productDetails };
    try {
      const response = await request('/stock-master-create', {
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response?.success) {
        toast('Stock details successfully submitted to StockMaster!', { variant: 'success' });
      } else {
        throw new Error('Failed to submit stock details.');
      }
    } catch (error) {
      toast(`Error: ${error.message}`, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };




  const handleRowProduct = (row) => {
    if (stock.data && stock.data.length > 0) {
      const allProductDetails = stock.data.flatMap((dataItem) => dataItem.productDetails || []);
      const matchingProducts = allProductDetails.filter(
        (product) => product.product === row.product
      );
      if (matchingProducts.length > 0) {
        setStockDetails(matchingProducts);
        console.log("Matching Stock Details", matchingProducts);
      } else {
        setStockDetails([]);
      }
    } else {
      setStockDetails([]);
    }
  };
  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Validate Room Transfer
              </Typography>
            </Stack>
            <Grid container spacing={2}>
              <Grid container spacing={2} sx={{ minHeight: '20rem' }}>
                {/* First Table */}
                <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Table
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={roomTransferDataObj.data || []}
                    columns={TABLE_HEADER}
                    size="small"
                    onRowClick={handleRowClick}
                    showAuthorize={true}
                    onAuthorizeHandler={formSubmit}
                  />
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Table
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={filterUniqueProducts(productDetails) || []}
                    columns={ROOM_HISTORY_HEADER}
                    size="small"
                    onRowClick={(row) => {
                      handleRowProduct(row)
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
